import { ICourseModulesNodes } from '@dtos/Course'
import { IEnrollment } from '@dtos/Enrollment'

interface IIsLastLessonOfPreviousSubmoduleCompletedProps {
  module: ICourseModulesNodes
  availableSubmodules: ICourseModulesNodes[]
  submoduleIndex: number
  enrollment: IEnrollment | null | undefined
}

export function isLastLessonOfPreviousSubmoduleCompleted({
  module,
  availableSubmodules,
  submoduleIndex,
  enrollment,
}: IIsLastLessonOfPreviousSubmoduleCompletedProps): boolean {
  const previousSubmodule = () => {
    if (submoduleIndex === 0) {
      return module.courseContents.nodes[module.courseContents.nodes.length - 1]
    }
    return availableSubmodules[submoduleIndex - 1].courseContents.nodes[
      availableSubmodules[submoduleIndex - 1].courseContents.nodes.length - 1
    ]
  }

  const previousSubmoduleLastLesson = previousSubmodule()

  return !!enrollment?.progressCard?.lessonsProgresses?.find(
    (lesson) => lesson.lessonId === previousSubmoduleLastLesson?.lesson.id,
  )?.completed
}
